import AddEditBooking from '@Containers/Booking/AddEditBooking';
const edit = () => <AddEditBooking />;

export default edit;
